import Swiper from "swiper";
import SwiperElement from "../molecules/SwiperElement";

/**
 * mobile advantage banner swiper on top of every page
 */

const swiperBannerParams = {
  loop: true,
  autoplay: true,
  speed: 500,
  navigation: {
    nextEl: ".advantage-banner--next-button",
    prevEl: ".advantage-banner--prev-button",
  },
  spaceBetween: 0,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
};

export class AdvantageBannerSwiper {
  private readonly swiperBanner: HTMLElement;

  constructor(swiperBanner: HTMLElement) {
    this.swiperBanner = swiperBanner;
    const _ = new Swiper(this.swiperBanner, swiperBannerParams);
    _.loaded = true;
  }
}

export class AdvantageBannerSwiperRedesign {
  public static run(section: HTMLElement): void {
    const swiperPreloader: HTMLElement | null = section.querySelector(".loading-placeholder");
    const swiperWrapper: HTMLElement | null = section.querySelector(".advantage-banner--swiper");

    // show advantage banner and remove placeholder once the swiper element is fully loaded
    if (swiperPreloader) {
      swiperPreloader.remove();
    }
    if (swiperWrapper) {
      swiperWrapper.style.display = "";
    }

    SwiperElement.run(section, swiperBannerParams);
  }
}
